import { render, staticRenderFns } from "./Royalties.vue?vue&type=template&id=514f2f7c&scoped=true&"
import script from "./Royalties.vue?vue&type=script&lang=js&"
export * from "./Royalties.vue?vue&type=script&lang=js&"
import style0 from "./Royalties.vue?vue&type=style&index=0&id=514f2f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f2f7c",
  null
  
)

export default component.exports